import { XF } from "./js/XF";

export function onetapCanShow() {
  // don't load on ios
  if (XF.browser?.os === "ios") return false;
  // don't load on android thread pages
  if (
    XF.browser?.os === "android" &&
    document.documentElement.dataset.template === "thread_view"
  )
    return false;
  return true;
}
